import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Award, Users, Target, Heart } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import PageHeader from '../common/PageHeader';
import Footer from '../common/Footer';

const About = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <PageHeader />

      <div className="container py-12 md:py-12">
        <div className="mx-auto flex max-w-[980px] flex-col items-center gap-4 text-center mb-16">
          <Badge variant="outline">Om oss</Badge>
          <h1 className="text-4xl font-bold tracking-tighter sm:text-5xl md:text-6xl">
            Professionella bildekaler för företag
          </h1>
          <p className="max-w-[750px] text-lg text-muted-foreground">
            Vi hjälper företag att synas och växa genom professionell fordonsprofilering.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 max-w-4xl mx-auto mb-16">
          <Card>
            <CardHeader>
              <Target className="h-8 w-8 mb-2" />
              <CardTitle>Vår Mission</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-base">
                Att göra det enkelt för företag att designa och beställa professionella bildekaler online.
              </CardDescription>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <Heart className="h-8 w-8 mb-2" />
              <CardTitle>Våra Värderingar</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-base">
                Kvalitet, transparens och kundnöjdhet i varje steg av processen.
              </CardDescription>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <Award className="h-8 w-8 mb-2" />
              <CardTitle>Vår Expertis</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-base">
                Över 10 års erfarenhet av fordonsprofilering och digitalt designverktyg.
              </CardDescription>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <Users className="h-8 w-8 mb-2" />
              <CardTitle>Våra Kunder</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-base">
                1000+ nöjda företagskunder som använder våra dekaler för att marknadsföra sig.
              </CardDescription>
            </CardContent>
          </Card>
        </div>

        <div className="text-center">
          <Button size="lg" onClick={() => navigate('/customize')}>
            Börja designa din firmabil
          </Button>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default About;

